import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import EditUnlocodeSelectionFormContainer from '../containers/EditUnlocodeSelectionFormContainer';
import Modal from '../../../../core/modules/common/components/Modal';

class EditUnlocodeSelectionModal extends Component {
  onSubmitSaveSelection = ({ name }) => {
    const condition = this.props.selections.map(sel => sel.name).includes(name !== undefined ? name.trim() : '');
    if (condition) {
      this.props.updateUI('error', 'app.admin.edit.preset.warning.message');
    } else {
      this.props.saveSelection({
        name,
        checkedUnlocodes: this.props.checkedUnlocodes,
      });
    }
  };

  render() {
    return (
      <Modal
        header={
          <FormattedMessage
            id="app.edit.unlocode.selection.form.title"
            tagName="h3"
          />
        }
        closeOnOutsideClick
        onClose={this.props.closeModal}
      >
        <EditUnlocodeSelectionFormContainer
          onSubmit={this.onSubmitSaveSelection}
          onCloseModal={this.props.closeModal}
          selections={this.props.selections}
          checkedUnlocodes={this.props.checkedUnlocodes}
          name={this.props.name}
        />
      </Modal>
    );
  }
}

EditUnlocodeSelectionModal.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    unlocodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  checkedUnlocodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  saveSelection: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  name: PropTypes.string,
};

export default (EditUnlocodeSelectionModal);
